export const NOTE_MIME_TYPE = 'mossText'
export const WEBLINK_MIME_TYPE = 'mossWeblink'
